export const BRAND_COLORS = ['#33475b', '#7fded2', '#d94c71', '#f5c26b', '#5e6ab8'];
export const LINEAR_GRADIENTS = {
  '#33475b': 'linear-gradient(0deg, rgb(81, 111, 144) 35%, rgb(41, 62, 84) 100%)',
  '#7fded2': 'linear-gradient(-225deg, rgb(80, 204, 204) 35%, rgb(69, 174, 202) 100%)',
  '#d94c71': 'linear-gradient(-225deg, rgb(241, 95, 121) 35%, rgb(178, 69, 146) 100%)',
  '#f5c26b': 'linear-gradient(-225deg, rgb(255, 195, 113) 20%, rgb(255, 95, 109) 100%)',
  '#5e6ab8': 'linear-gradient(-225deg, rgb(117, 93, 213) 35%, rgb(55, 136, 209) 100%)'
};